import { Outlet } from 'react-router-dom'
import LanguagePicker from '../i18n/LanguagePicker'
import './styles/onboarding.css'

export default function OnboardingLayout() {
  return (
    <div className="onboarding-page">
      <header className="onboarding-page__header">
        <a href="/" className="onboarding-page__logo" style={{ textDecoration: 'none' }}>
          community<span>nord</span>.com/onboarding
        </a>
        <div className="onboarding-page__lang">
          <LanguagePicker />
        </div>
      </header>

      <main className="onboarding-page__main">
        <Outlet />
      </main>

      <footer className="onboarding-page__footer">
        © {new Date().getFullYear()} CommunityNord
      </footer>
    </div>
  )
}
